import { RxJSCurrentState, useRxJSState } from '../../React/Common/Hooks/useRxJSState'
import { currentUserState$ } from '../../NonReact/common/RxJS/UserInfoState'
import { displayError } from '../../React/Common/Utils/Messages'
import { useIsScheduledReport } from '../../React/Common/Hooks/useIsScheduledReport'
import { AdminUserResponse, CurrentUserResponse } from '../../NonReact/common/Types/Types'

export type UserInfo = RxJSCurrentState<AdminUserResponse>

export const useUserInfo = (shouldDisableError?: boolean): UserInfo => {
    const isScheduledReport: boolean = useIsScheduledReport()

    return useRxJSState<
        AdminUserResponse,
        (isCacheBusted?: boolean, errorHandler?: (error: Error) => void) => Promise<Nullable<CurrentUserResponse>>
    >(currentUserState$, undefined, false, shouldDisableError || isScheduledReport ? undefined : displayError)
}
